// API URL
export const API_BASE = process.env.API_BASE
export const API_URL = process.env.API_URL
export const FILE_STORAGE = process.env.FILE_STORAGE
export const FILE_STORAGE_API = process.env.FILE_STORAGE_API

export const CarRentalSystemTypes = {
  NONE: 0,
  RENTLOG: 1
}

export const RenderTypes = {
  NONE: 0,
  FORMATTER: 1,
  INPUT: 2,
  CHECKBOX: 3,
  DATETIME: 4,
  SELECTLIST: 5,
  RADIOLIST: 6,
  CHECKBOXLIST: 7,
  INPUTFIELD2: 8,
  SELECTLIST2: 9,
  INPUTICON: 10,
  CHECKBOXICON: 11,
  TEXTAREA: 12
}

export const OrderSteps = {
  NEW_ORDER: 1,
  DISASSEMBLY: 101,
  REPAIR: 102,
  BODY_PAINTING: 105,
  PREPARING: 2,
  FILLING: 3,
  SANDING: 4,
  PAINTING: 5,
  FINISHING: 6,
  ASSEMBLY: 103,
  BODY_FINISHING: 104,
  DELIVERY: 7,
  ARCHIVE: 8

}

export const SparepartStatus = {
  NONE: 0,
  UNKNOWN: 1,
  NOTINUSE: 2,
  INSTOCK: 4,
  ORDERED: 8,
  RECEIVED: 16,
  DEFECTIVE: 32,
  INCORRECT: 64,
  BACKORDER: 128
}

export const OrderTypes = {
  Insurance: 1,
  Selling: 2,
  FactoryWarranty: 3,
  Other: 4,
  Complaint: 5,
  Private: 6
}

export const DracarAllowOrderTypes = [
  OrderTypes.Insurance,
  OrderTypes.FactoryWarranty,
  OrderTypes.Private,
  OrderTypes.Selling
]

export const AccountingSystemTypes = {
  None: 0,
  Economic: 1,
  Helios: 2,
  C5: 3,
  // KeyLoop/Dracar
  Dracar: 4,
  // 24SevenOffice
  TFSO: 5,
  // KeyLoop/AutoLine
  AutoLine: 6
}

export const DracarJobFeeSettingType = {
  LABOR_1: 1,                  // 1
  BODYSHOP_ENVIRONMENT_2: 2,    // 68D
  SUNDRYPARTS_MATERIAL_3: 3,    // 36D
  SUNDRYPARTS_TOTAL_4: 4,       // 37D
  HOLLOW_CAVITY_SEALANT_5: 5,    // 30D
  PAINT_6: 6,                  // 53D
  PAINT_ENVIRONMENT_7: 7,       // 58D
  DIFFERENCE_INSURANCE_8: 8,    // 99D
  AUTOLINE_CONSUMABLES_9: 9     // WFOR
}

export const BookingTimesSectionType = {
  Pickup: 0, // 'Pickup'
  Production: 1, // 'ProductionDate'
  Delivery: 2, // 'Delivery',
  LeadTime: 3 // LeadTime determine body workdays. default is 5
}

export const AssessmentReporType = {
  Unknown: 0,
  Forsi: 1,
  ForsiManual: 2,
  DBS: 3
}

export const AssessmentSystemType = {
  None: 0,
  Forsi: 1,
  DBS: 2
}

export const DepartmentType = {
  Paint: 0,
  Body: 1,
  Both: 2
}

// Browsers & Devices (TODO: add browser checks here)
export const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

// Auth constants
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'
export const LOGIN_AS_USER = 'LOGIN_AS_USER'
export const SET_LOGIN_AS = 'SET_LOGIN_AS'
export const SET_LOGINTIMER = 'SET_LOGINTIMER'
export const SET_WORKSCREEN = 'SET_WORKSCREEN'
export const SET_PREV_WORKSCREEN = 'SET_PREV_WORKSCREEN'
export const SET_ACCOUNTING_TYPE = 'SET_ACCOUNTING_TYPE'
export const SET_ALLOW_NO_CUSTOMER = 'SET_ALLOW_NO_CUSTOMER'
export const SET_CAR_RENTALSYSTEM_TYPE = 'SET_CAR_RENTALSYSTEM_TYPE'
export const SET_COMPANY_HAVE_ASSIGNED_ESG = 'SET_COMPANY_HAVE_ASSIGNED_ESG'
// Orders constants
export const SET_ORDER = 'SET_ORDER'
export const SET_ORDERS = 'SET_ORDERS'
export const SET_ORDER_BOOKING_TIMES = 'SET_ORDER_BOOKING_TIMES'
export const SET_WORKSCREEN_ORDERS = 'SET_WORKSCREEN_ORDERS'
export const SET_WORKCARD_ORDER = 'SET_WORKCARD_ORDER'
export const SET_ORDERS_ERRORS = 'SET_ORDERS_ERRORS'
export const SET_ORDER_FILTER = 'SET_ORDER_FILTER'
export const SET_ORDERLIST_FILTER = 'SET_ORDERLIST_FILTER'
export const SET_WORKSCREEN_ORDER_FILTER = 'SET_WORKSCREEN_ORDER_FILTER'
export const SET_CUSTOMER_ORDER_FILTER = 'SET_CUSTOMER_ORDER_FILTER'
export const SET_WP_ORDER_FILTER = 'SET_WP_ORDER_FILTER'
export const RESET_ORDER_FILTER = 'RESET_ORDER_FILTER'
export const RESET_ORDERLIST_FILTER = 'RESET_ORDERLIST_FILTER'
export const RESET_WORKSCREEN_ORDER_FILTER = 'RESET_WORKSCREEN_ORDER_FILTER'
export const RESET_CUSTOMER_ORDER_FILTER = 'RESET_CUSTOMER_ORDER_FILTER'
export const RESET_WP_ORDER_FILTER = 'RESET_WP_ORDER_FILTER'
export const SET_SIMPLESEARCH = 'SET_SIMPLESEARCH'
export const SET_SIMPLESEARCH_WORKSCREEN = 'SET_SIMPLESEARCH_WORKSCREEN'
export const RESET_SIMPLESEARCH = 'RESET_SIMPLESEARCH'
export const RESET_SIMPLESEARCH_WORKSCREEN = 'RESET_SIMPLESEARCH_WORKSCREEN'
export const SET_ORDERS_SEARCH = 'SET_ORDERS_SEARCH'
export const SET_LAST_VISITED_ORDER = 'SET_LAST_VISITED_ORDER'

// Assign
export const SET_ACTIVE_EMPLOYEES = 'SET_ACTIVE_EMPLOYEES'
export const SET_STEP_ASSIGNMENTS = 'SET_STEP_ASSIGNMENTS'

// Price calculation
export const SET_PRICECALC_PRICES = 'SET_PRICECALC_PRICES'
export const OPEN_POPUP_PARTS = 'OPEN_POPUP_PARTS'
export const SET_CAR_PARTS = 'SET_CAR_PARTS'
export const SET_CAR_PRICEPARTS = 'SET_CAR_PRICEPARTS'
export const SET_CAR_SELECTED_PARTS = 'SET_CAR_SELECTED_PARTS'
export const SET_CAR_ITEMS = 'SET_CAR_ITEMS'

// Backdrop
export const OPEN_MENU = 'OPEN_MENU'
export const OPEN_POPUP = 'OPEN_POPUP'
export const OPEN_POPUP_BG = 'OPEN_POPUP_BG'
export const SET_INFO_MODAL = 'SET_INFO_MODAL'
export const BODY_SCROLL = 'BODY_SCROLL'

// Common
export const UPDATE_TASKS_WORKSCREEN = 'UPDATE_TASKS_WORKSCREEN'
export const SET_PRICEMODEL_LIST = 'SET_PRICEMODEL_LIST'
export const SET_PHONECODES = 'SET_PHONECODES'
export const SET_VEHICLE_LOOKUP_SEVICES = 'SET_VEHICLE_LOOKUP_SEVICES'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_ACTIVE_CUSTOMER = 'SET_ACTIVE_CUSTOMER'
export const SET_CUSTOMERGROUPS = 'SET_CUSTOMERGROUPS'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_BRANDS = 'SET_BRANDS'
export const SET_ENUMS = 'SET_ENUMS'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_DEFAULT_PHONECODE = 'SET_DEFAULT_PHONECODE'
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE'
export const SET_CURRENCY_CODE = 'SET_CURRENCY_CODE'
export const SET_HAS_PAINT_PARTNER = 'SET_HAS_PAINT_PARTNER'
export const SET_HAS_PARTNER = 'SET_HAS_PARTNER'
// export const SET_ALLOWCARRENTALOVERVIEW = 'SET_ALLOWCARRENTALOVERVIEW'
export const SET_DEPARTMENT_TYPE = 'SET_DEPARTMENT_TYPE'
export const SET_ALLOW_CHANGE_DELIVERY = 'SET_ALLOW_CHANGE_DELIVERY'
export const SET_ORDERLIST_USE_TIME_PICUP = 'SET_ORDERLIST_USE_TIME_PICUP'
export const SET_SHOP_ACTIVE_PUNCHCLOCK = 'SET_SHOP_ACTIVE_PUNCHCLOCK'
export const SET_NEW_ORDERS_GROUPING = 'SET_NEW_ORDERS_GROUPING'
export const SET_EMPLOYEES = 'SET_EMPLOYEES'
export const SET_HEADERINFO = 'SET_HEADERINFO'
export const SET_HEADERINFO_FORSI = 'SET_HEADERINFO_FORSI'
export const SET_HEADERINFO_UPDATES = 'SET_HEADERINFO_UPDATES'
export const SET_HEADERINFO_EVALUATION = 'SET_HEADERINFO_EVALUATION'
export const SET_HEADERINFO_MESSAGES = 'SET_HEADERINFO_MESSAGES'
export const SET_HEADERINFO_TASKS = 'SET_HEADERINFO_TASKS'
export const SET_HEADERINFO_CHAINNOTIFICATION = 'SET_HEADERINFO_CHAINNOTIFICATION'
export const SET_HEADERINFO_ORDERS = 'SET_HEADERINFO_ORDERS'
export const SET_HEADERINFO_BOOKINGPORTALDRAFTS = 'SET_HEADERINFO_BOOKINGPORTALDRAFTS'
export const SET_COLLABORATING_PARTNERS = 'SET_COLLABORATING_PARTNERS'
export const SET_BODY_DEFAULT_LEAD_TIME = 'SET_BODY_DEFAULT_LEAD_TIME'
export const ALL_LANGS = [
  {
    LanguageName: 'Danish',
    SelfLangName: 'Dansk',
    Image: '/images/svgs/menuicons/Dansk.svg',
    LanguageCode: 'DK'
  },
  {
    LanguageName: 'English',
    SelfLangName: 'English',
    Image: '/images/svgs/menuicons/English.svg',
    LanguageCode: 'EN'
  },
  {
    LanguageName: 'Swedish',
    SelfLangName: 'Svenska',
    Image: '/images/svgs/menuicons/Svenska.svg',
    LanguageCode: 'S'
  },
  {
    LanguageName: 'Norwegian',
    SelfLangName: 'Norsk',
    Image: '/images/svgs/menuicons/Norsk.svg',
    LanguageCode: 'NO'
  }
]

// Commit

// File
export const SET_UPLOADS = 'SET_UPLOADS'
export const FINISH_UPLOADS = 'FINISH_UPLOADS'

// Car
export const SET_CAR_ACTIVE_STATE = 'SET_CAR_ACTIVE_STATE'

// UI
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_PAGE_TITLE_EXTRA = 'SET_PAGE_TITLE_EXTRA'
export const SET_POPUPS = 'SET_POPUPS'
export const SET_HELPICON_POPUP_UPDATES = 'SET_HELPICON_POPUP_UPDATES'
export const SET_OVERLAYS = 'SET_OVERLAYS'
export const SET_SLIDEPANELS = 'SET_SLIDEPANELS'

// Spare parts
export const SET_SPARE_PARTS_ORDERING = 'SET_SPARE_PARTS_ORDERING'
export const SET_SPARE_PARTS_RECEPTION = 'SET_SPARE_PARTS_RECEPTION'
export const SET_SPARE_PARTS_FOR_MATCHING = 'SET_SPARE_PARTS_FOR_MATCHING'

// Embedded booking
export const SET_EMBEDDED_BOOKING_CARDATA = 'SET_EMBEDDED_BOOKING_CARDATA'
export const SET_EMBEDDED_BOOKING_IMAGES = 'SET_EMBEDDED_BOOKING_IMAGES'
export const SET_EMBEDDED_BOOKING_DAMAGE_COMMENT = 'SET_EMBEDDED_BOOKING_DAMAGE_COMMENT'
export const SET_EMBEDDED_BOOKING_OTHERINFO = 'SET_EMBEDDED_BOOKING_OTHERINFO'
export const SET_EMBEDDED_BOOKING_CONTACTINFO = 'SET_EMBEDDED_BOOKING_CONTACTINFO'
export const SET_EMBEDDED_BOOKING_DATA = 'SET_EMBEDDED_BOOKING_DATA'

export const SET_EMBEDDED_INSURANCE_COMPANIES = 'SET_EMBEDDED_INSURANCE_COMPANIES'
export const SET_EMBEDDED_CARRENTAL_ALTERNATIVES = 'SET_EMBEDDED_CARRENTAL_ALTERNATIVES'

// Overview
export const SET_DELIVERY_STATUS = 'SET_DELIVERY_STATUS'
export const SET_PICKUP_STATUS = 'SET_PICKUP_STATU'
export const SET_PRODUCTION_STATUS = 'SET_PRODUCTION_STATUS '



// WEBPACK FOOTER //
// ./src/app/constants.js